import {h, Fragment} from "preact"
import { useResponse, Keywords, AutocompleteElement, useCurrencyFormatting, useProductFilters } from "@nosto/preact"
import { productImagePlaceholder } from "../helpers"
import SubmitButton from "./elements/SubmitButton"
import AutocompleteProduct from "./AutocompleteProduct"

export default function Autocomplete() {
    const { products, keywords } = useResponse();
    const { format } = useCurrencyFormatting();
    const masterColors = Shopify.masterColor;
    const { filters } = useProductFilters();

    if (!products?.hits?.length && !keywords?.hits?.length) {
        return
    }
    
    return (
        <div
            class="ns-autocomplete ns-fixed ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-mx-auto"
            data-nosto-element="autocomplete"
        >
            <div class="ns-w-100 ns-h-100">
                <div class="ns-d-flex ns-flex-column ns-flex-sm-row ns-h-100">
                    {keywords?.hits?.length > 0 && (
                        <div
                            class={`ns-autocomplete-keywords ns-d-flex ns-flex-column ns-col-12 ${
                                products?.hits?.length > 0 ? "ns-col-sm-4" : "ns-col-sm-12"
                            }`}
                        >
                            {/* <div class="ns-color-black ns-py-2 ns-px-4 ns-font-medium ns-font-4">
                                Keywords
                            </div> */}
                            <div class="ns-d-flex ns-flex-column">
                                <Keywords
                                    hits={keywords.hits}
                                    keywordComponent={Keyword}
                                    elementComponent={Element}
                                    keywordInCategoryComponent={KeywordInCategory}
                                />
                            </div>
                            {!products?.hits?.length && <SubmitButton text="See all search results" />}
                        </div>
                    )}
                    {products?.hits?.length > 0 && (
                        <div class="ns-autocomplete-products ns-d-flex ns-flex-column ns-flex-grow-1">
                            {/* <div class="ns-color-black ns-py-2 ns-px-4 ns-font-medium ns-font-4">
                                Products
                            </div> */}
                            <div class="ns-d-flex">
                                {products?.hits?.map((hit, index) => {
                                    return (
                                        <AutocompleteProduct 
                                            hit={hit}
                                            product={hit}
                                            key={hit?.productId || index}
                                            masterColors={masterColors}
                                            filters={filters}
                                         />
                                    )
                                })}
                            </div>
                            <SubmitButton text="See all search results" />
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

function Keyword({ hit }) {
    return (
        <span data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <AutocompleteElement hit={hit} filter={filter} class="ns-clickable ns-py-2 ns-px-4 ns-font-5">
            {keywordComponent}
        </AutocompleteElement>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <span class="ns-clickable">
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}
